import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../services/api';
import { useHapticFeedback } from '../hooks/useTelegram';
import './OnboardingPage.css';

interface ShortOnboardingPageProps {
  onComplete: () => void;
  onShowFullOnboarding: () => void;
}

const ShortOnboardingPage: React.FC<ShortOnboardingPageProps> = ({ 
  onComplete, 
  onShowFullOnboarding 
}) => {
  const [loading, setLoading] = useState(false);
  const { notification } = useHapticFeedback();
  const navigate = useNavigate();

  const handleParticipate = useCallback(async () => {
    try {
      setLoading(true);
      notification('success');
      const redirectPath = await apiClient.getPostOnboardingRedirectPath();
      navigate(redirectPath);
      onComplete();
    } finally {
      setLoading(false);
    }
  }, [onComplete, notification, navigate]);

  const handleMoreInfo = useCallback(() => {
    onShowFullOnboarding();
  }, [onShowFullOnboarding]);

  return (
    <div className="onboarding-page">
      <div className="onboarding-content">
        <div className="onboarding-step short-onboarding-step">
          <div className="step-header">
            <h2 className="step-title">Не упусти свой ху#!</h2>
            <p className="step-subtitle">
              Это твой шанс урвать уникальные цифровые картинки и а#уенные призы
            </p>
            <div className="step-image-center">
              <img src="/onbshort.png" alt="NFT-акция" className="step-inline-image" />
            </div>
          </div>

          <div className="step-body short-onboarding-body">
            <div className="short-onboarding-points">
              <div className="short-onboarding-point">
                <span className="point-text">
                  <span className="highlight-word">Неху# медлить!</span><br />Вступай в самый ху#вый проект Рунета
                </span>
              </div>
              <div className="short-onboarding-point">
                <span className="point-text">
                  <span className="highlight-word">Лови ху#!</span><br />Бери первый ху#к бесплатно, потом будут дох#я стоить. Кто успел, тот и съел!
                </span>
              </div>
            </div>
          </div>

          <div className="step-footer short-onboarding-footer">
            <button 
              className="primary-button" 
              onClick={handleParticipate}
              disabled={loading}
            >
              {loading ? 'Загрузка...' : 'Забрать ху#к'}
            </button>
            <button 
              className="secondary-button" 
              onClick={handleMoreInfo}
              disabled={loading}
            >
              Узнать больше
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShortOnboardingPage;
